import React from "react";

import { Card as PrCard } from "primereact/card";

import css from "./card.module.css";

const Card = ({ children }) => <PrCard className={css.card}>{children}</PrCard>;

export default Card;
